var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-percent-pond',{key:_vm.refreshFlagKey,staticStyle:{"width":"100%","height":"100%"},attrs:{"config":_vm.pondConfig}})}
var staticRenderFns = []

export { render, staticRenderFns }